import React, { lazy, Suspense } from 'react';
import { initializeWidget } from '@myinterview/zendesk-utils';
import { Routes, Route } from 'react-router-dom';
import './i18n/config';
import { updateZendeskFields } from './utils/utils';

const CompanyWelcomePageWrapper = lazy(() => import('./views/CompanyWelcomePage/Wrapper'));
const NotFound = lazy(() => import('./views/NotFound'));
const Main = lazy(() => import('./views/Main'));

const isProd = process.env.REACT_APP_ENV === 'production';
initializeWidget(!isProd);
updateZendeskFields();

const App = () => (
  <div className="app">
    <Suspense fallback={null}>
      <Routes>
        <Route path="/:jobId/:companySlug/:jobSlug" element={<Main />} />
        <Route path="/:companySlug/:jobSlug" element={<Main />} />
        <Route path="/:candidateId" element={<Main isPrivateLink />} />
        <Route path="/:jobId/:companySlug/:jobSlug/welcome/*" element={<CompanyWelcomePageWrapper />} />
        <Route path="/:companySlug/:jobSlug/welcome/*" element={<CompanyWelcomePageWrapper />} />
        <Route path="/:candidateId/welcome/*" element={<CompanyWelcomePageWrapper isPrivateLink />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </div>
);

export default App;
